// const apiPath = 'https://app3.ruby-report.com/api';
// const apiPath = 'https://app2.ruby-report.com/api';
// const apiPath = 'https://rubyreport.fruitcake.dev/api';
// const apiPath = 'http://rubyreport.barry.dev.fruitcake.nl/api';
// const apiPath = 'http://rubyreport.test/api';
const apiPath = '/api';

export const api = {
    baseUrl: apiPath,
    current: apiPath + '/v1'
};
